module.exports = __webpack_public_path__ + "img/my-lab.aad3db6b.svg";